export default __webpack_public_path__ + "static/media/Service5.8b1d9368.jpg";